import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Button, Container, Row, Col, Card, Tab, Tabs } from 'react-bootstrap';

import ConsultaCliente from '../../../../../lib/json/consultas/Clientes.json'
import ConsultaFunilEtapaInicio from '../../../../../lib/json/consultas/FunilEtapaInicio.json'
import ConsultaFormularioDinamicoCRM from '../../../../../lib/json/consultas/FormularioDinamicoCRM.json'
import { ConsultaAPI, ConsultaAPI_URL } from '../../../../../backend/ConsultaAPI';
import { ErroMsg, formatarComoMoeda, formatarData, RetornaUsuarioLogado, SucessoMsg } from '../../../../contents/VariaveisGlobais';
import LoadingSpinner from '../../../../components/LoadinSpinner';
import { ConsumoAPI_FileUpload, ConsumoAPI_POST, ConsumoAPI_PUT } from '../../../../../backend/ConsumoAPI';
import { Navigate, useNavigate } from 'react-router-dom';
import { usePopUp } from '../../../../components/BootBox';
import { toast } from 'react-toastify';

import { SDivDuplicar } from './styles'
import SelectDinamico from '../../../../components/SelectDinamico';
import InputGeral from '../../../../components/InputGeral/Index';
import ResponsiveDataTable from '../../../../components/DataTable';
import UploadFiles from '../../../../components/UploadFiles';

function handleAnexosCRM(item){
    const anexoUpload = JSON.parse(item.value)
    
    return ( 
        <div>
            <div><strong>Anexos: </strong></div>
                <UploadFiles 
                    value={[anexoUpload]}
                    disabled={true}
                />
        </div> 
    )
}

function handleValorMonetario(item){
    const valor = item.value || '0'
    
    return formatarComoMoeda(valor)
}

function handleData(item){
    const valor = item.value;

    return formatarData(valor)
}

// function handleNomeUsuario(item){
//     const valor = item.value
    
//     return valor
// }

function FormularioCRM({ Id, CategoriaId, EtapaId, IdOrigem, FormIndice, FormAtual, Etapas, FormInclusao } ) {
    const navigate = useNavigate();
    
    const [revisaoAberto, setRevisaoAberto] = useState(false);
    const [fields, setFields] = useState([]);
    const [dataUsers, setDataUsers] = useState([{}]);
    const [formData, setFormData] = useState({});
    const [formAlterado, setFormAlterado] = useState([]);
    const [history, setHistory] = useState([]);
    const [dataAnexos, setDataAnexos] = useState([]);
    const [dataNegocios, setDataNegocios] = useState([]);
    const [isInclusao, setIsInclusao] = useState(FormInclusao);
    const [campoNumeroOrcamento, setCampoNumeroOrcamento] = useState();
    const [campoCliente, setCampoCliente] = useState({value: '', label: 'Selecione o Cliente'});
    const [campoTitulo, setCampoTitulo] = useState();
    const [campoRevisaoTecnica, setCampoRevisaoTecnica] = useState(0);
    const [campoRevisaoComercial, setCampoRevisaoComercial] = useState(0);
    const [orcamentista, setOrcamentista] = useState('');
    const [comercial, setComercial] = useState('');
    const [titleForm, setTitleForm] = useState();
    const [activeTab, setActiveTab] = useState("Principal");
    const [campoFile, setCampoFile] = useState([]);
    const FormAtivo = (FormIndice != FormAtual)
            

    var usuario = RetornaUsuarioLogado()
    var [carregar, setCarregar] = useState(false);
    
    useEffect(() => {
        const fetchUser = async() => {
            let aDataUsers = []

            try {
                // Construct the public URL for the JSON file
                const jsonUrl = `usuarioSistema`;				
				const response = await ConsultaAPI_URL(jsonUrl);
                
                aDataUsers = response.usuarios.map( (item) => { return {Id: item.usuario, Descricao: item.nome }} );
            } catch (error) {
                console.error('Error fetching JSON:', error);
            }

            setDataUsers(aDataUsers);
            FormDinamico();
            fetchHistory();
            fetchAnexos();
            fetchNegocios();
        }

        fetchUser();
    }, []);

    const fetchNegocios = async() => {
        let retNegocios = await ConsultaAPI(`SELECT 
            RevisaoComercial,
            RevisaoTecnica,
            MAX(CASE WHEN PerguntaId = 24 THEN CAST(Resposta AS VARCHAR(MAX)) END) AS DataPropostaComercial,
            MAX(CASE WHEN PerguntaId = 26 THEN CAST(Resposta AS VARCHAR(MAX)) END) AS DataPropostaTecnica,
            MAX(CASE WHEN PerguntaId = 27 THEN CAST(Resposta AS VARCHAR(MAX)) END) AS Valor,
            MAX(CASE WHEN PerguntaId = 32 THEN CAST(Resposta AS VARCHAR(MAX)) END) AS ResponsavelpeloOrcamento,	
            MAX(CASE WHEN PerguntaId = 40 THEN CAST(Resposta AS VARCHAR(MAX)) END) AS ValorFechamento,
            MAX(CASE WHEN PerguntaId = 51 THEN CAST(Resposta AS VARCHAR(MAX)) END) AS ValorCusto,
            MAX(CASE WHEN PerguntaId = 52 THEN CAST(Resposta AS VARCHAR(MAX)) END) AS ValorAprovacaoCusto,
            MAX(CASE WHEN PerguntaId = 57 THEN CAST(Resposta AS VARCHAR(MAX)) END) AS ValorPropostaComercial,
            (SELECT Resposta FROM dbo.ProcessosCRMRespostas INNER JOIN ProcessosCRM ON ProcessosCRM.Id = ProcessoCRMId WHERE ProcessosCRM.IdOrigem = 21 And PerguntaId = 11) Classificacao
        FROM dbo.ProcessosCRMRespostas
        INNER JOIN ProcessosCRM ON ProcessosCRM.Id = ProcessoCRMId
        WHERE ProcessosCRM.IdOrigem = '${IdOrigem}' 
        AND ProcessosCRM.CategoriaId = 3 AND PerguntaId IN (24, 26, 27, 32, 40, 51, 52, 57 )
        GROUP BY RevisaoComercial, RevisaoTecnica`);
       
        if (retNegocios.data) {
            let data = retNegocios.data

            setDataNegocios(data);
        }
    }

    const fetchAnexos = async() => {
        // Substitua pela chamada real à sua API para buscar o histórico de alterações
        let retHistory = await ConsultaAPI(`SELECT * FROM AnexosCRM WHERE ProcessoCRMId = '${IdOrigem}'`);
        
        if (retHistory.data) {
            let data = retHistory.data

            setDataAnexos(data);
        }
    }

    const FormDinamico = async () => {
        let consulta = ConsultaFormularioDinamicoCRM.consulta

        if (!isInclusao){
            consulta = consulta.replace("@CAMPOS", ", Formulario.Obrigatorio, Formulario.HabilitadoPreenchimento, Resposta.Resposta, Pergunta IdPergunta, Processo.*, (SELECT COUNT(*) FROM dbo.ProcessosCRM PCRM WHERE PCRM.Status = 'A' AND PCRM.Id != Processo.Id AND PCRM.IdOrigem = Processo.IdOrigem AND ( PCRM.RevisaoComercial <> Processo.RevisaoComercial OR PCRM.RevisaoTecnica <> Processo.RevisaoTecnica ) ) EmRevisao ")
            consulta += ` INNER JOIN dbo.ProcessosCRMRespostas Resposta ON  Resposta.EtapaId = EtapasId AND Resposta.PerguntaId = Pergunta 
                          INNER JOIN dbo.ProcessosCRM Processo ON Processo.Id = Resposta.ProcessoCRMId AND Processo.Id = '${Id}' AND Processo.Id = Resposta.ProcessoCRMId `
        }else{
            consulta = consulta.replace("@CAMPOS", ", Formulario.Obrigatorio, Formulario.HabilitadoPreenchimento, Pergunta IdPergunta ")
        }
            
        consulta += ` WHERE EtapasId = '${EtapaId}' `;

        let retConsulta = await ConsultaAPI(consulta);

        if (retConsulta.data) {
            let dados = retConsulta.data;

            dados.map((item) => {
                let option = item.OpcoesResposta;
                let newData = option ? option.split(';').map((item) => { return item }) : [];

                item.options = newData;
            });

            // Preencher formData com os valores iniciais dos campos
            let initialFormData = {};
            dados.forEach(field => {
                if (field.Id == '35'){
                    let revisaoTecnica = dados[0].RevisaoTecnica ? dados[0].RevisaoTecnica : 0
                    initialFormData[field.IdPergunta] = revisaoTecnica;
                }else if (field.Id == '36'){
                    let revisaoComercial = dados[0].RevisaoComercial ? dados[0].RevisaoTecnica : 0
                    initialFormData[field.IdPergunta] = revisaoComercial;
                }else {
                    initialFormData[field.IdPergunta] = field.Resposta || ''.trim();
                }
            });

            setRevisaoAberto(dados[0].EmRevisao == 1 ? true : false)

            setFields(dados);
            setFormData(initialFormData);

            if (dados[0].NumeroOrcamento)
                setCampoNumeroOrcamento(dados[0].NumeroOrcamento)
            
            if (dados[0].Cliente)
                setCampoCliente({value: dados[0].Cliente, label: dados[0].ClienteNome + ' - ' + dados[0].ClienteUnidade + ' - Contato: ' + dados[0].ClienteContato})
            
            if (dados[0].Titulo)
                setCampoTitulo(dados[0].Titulo)
            
            if (dados[0].RevisaoTecnica)
                setCampoRevisaoTecnica(dados[0].RevisaoTecnica || 0)
                
            if (dados[0].RevisaoComercial)
                setCampoRevisaoComercial(dados[0].RevisaoComercial || 0)

            if (dados[0].EtapasDescricao)
                setTitleForm(dados[0].EtapasDescricao)

            if (dados[0].ResponsavelOrcamento)
                setOrcamentista(dados[0].ResponsavelOrcamento)

            if (dados[0].ResponsavelComercial)
                setComercial(dados[0].ResponsavelComercial)
        }
    };

    useEffect(() => {
        // Configurando o intervalo para 1 minuto (60000 milissegundos)
        const intervalId = setInterval(fetchHistory, 60000);

        // Limpeza do intervalo quando o componente desmontar
        return () => clearInterval(intervalId);
    }, []);

    const fetchHistory = async () => {
        // Substitua pela chamada real à sua API para buscar o histórico de alterações
        let retHistory = await ConsultaAPI(`SELECT *, CONVERT(VARCHAR, Data, 103) DataFormatada, CAST(Hora AS CHAR(8)) HoraFormatada FROM HistoricoAlteracoes WHERE ProcessoCRMId = '${Id}' ORDER BY Data DESC, Hora Desc`);
        if (retHistory.data) {
            setHistory(retHistory.data);
        }
    };

    const handleChange = (e) => {
        const { id, value, type, checked, files } = e.target;

        setFormData(prevState => {
            let updatedFormData;

            if (type === 'checkbox') {
                updatedFormData = {
                    ...prevState,
                    [id]: {
                        ...prevState[id],
                        [value]: checked
                    }
                };
            } else if (type === 'file') {
                updatedFormData = {
                    ...prevState,
                    [id]: files[0]
                };
            } else {
                updatedFormData = {
                    ...prevState,
                    [id]: value
                };
            }

            // Verificar se o valor realmente mudou
            const hasChanged = type === 'checkbox'
                ? prevState[id] && prevState[id][value] !== checked
                : prevState[id] !== value;

            if (hasChanged) {
                setFormAlterado(prevFormAlterado => {
                    // Adicionar o ID ao formAlterado se não estiver presente
                    if (!prevFormAlterado.includes(id)) {
                        return [...prevFormAlterado, id];
                    }
                    return prevFormAlterado;
                });
            }

            return updatedFormData;
        });
    };

    const handleonBlur = async (e) => {
        const { id, value } = e.target;
        const pergunta = fields.filter(item => item.IdPergunta.toString() === id)[0];

        if (!isInclusao && formAlterado.includes(id)) {
            const jsonSalvar = { 
                idProcesso: Id,
                idOrigem: IdOrigem,
                descricaoPergunta: pergunta.Descricao,
                Resposta: value,
                usuario: usuario.nome
            };

            try {
                const rota = 'processosCRM/interacao/' + id;
                const retConsumo = await ConsumoAPI_PUT(rota, jsonSalvar);
            } catch (error) {
                console.error('Error in handleSalvar:', error);
            }
        }
    };

    const handleSubmit = async(e) => {
        e.preventDefault(); // Previne o comportamento padrão de recarregar a página

        if (!campoCliente){
            ErroMsg("Favor preencher o campo Cliente");
            return false
        }

        let jsonSalvar = {
            idOrigem: IdOrigem,
            Cliente: campoCliente,
            campos: []
        };
        
        let etapaAtual = Etapas[FormAtual]
        let fimCategoria = FormAtual === Etapas.length -1
        let etapaSeguinte = Etapas[!fimCategoria ? FormAtual + 1: FormAtual]
        let numeroOrcamento = campoNumeroOrcamento
        let titulo = campoTitulo
        let proximaEtapa = {
            categoria: fimCategoria ? null : etapaSeguinte.CategoriasId, 
            categoriaDescricao: fimCategoria ? null : etapaSeguinte.CategoriasDescricao, 
            etapa: fimCategoria ? null : etapaSeguinte.EtapasId, 
            etapaDescricao: fimCategoria ? null : etapaSeguinte.EtapasDescricao,
            categoriaDuplica: null,
            categoriaDuplicaDescricao: null,
            etapaDuplica: null,
            etapaDuplicaDescricao: null,
            OrdemCategoria: etapaAtual.OrdemCat,
            OrdemEtapaCategoria: etapaAtual.Ordem
        }

        let responsavelComercial = comercial || '';
        let responsavelOrcamento = orcamentista || '';
        let NumeroRevisaoTecnica = campoRevisaoTecnica;
        let NumeroRevisaoComercial = campoRevisaoComercial;
        let revisaoTecnica;
        let revisaoComercial;

        Object.keys(formData).forEach(key => {
            const pergunta = fields.filter( (item) => item.IdPergunta.toString() === key)[0]
            jsonSalvar.campos.push({ pergunta: key, descricao: pergunta.Descricao, valor: formData[key]});

            if (etapaAtual.TipoRegra === 4 && etapaAtual.PerguntaIdRegra.toString() === key ){
                switch (etapaAtual.CampoTabela) {
                    case 'Orcamento':
                        numeroOrcamento = formData[key]
                        break;                
                    case 'Titulo':
                        titulo = formData[key]
                        break;                
                    case 'ResponsavelComercial':   
                        responsavelComercial = formData[key]
                        break;                
                    case 'ResponsavelOrcamento':                        
                        responsavelOrcamento = formData[key]
                        break;                
                    case 'RevisaoTecnica':    
                        revisaoTecnica = formData[key]
                        revisaoComercial = formData['36'] // Definido no Código,achar solução melhor
                        break;                
                    default:
                        break;
                }
            }

            //Verifica se possui a Pergunta do Responsável Orçamento
            if (key === '32'){
                responsavelOrcamento = formData[key]
            }
            
            //Verifica se possui a Regra de Definir a proxima etapa, de acordo com alguma resposta preenchida
            if (etapaAtual.TipoRegra === 3 && etapaAtual.PerguntaIdRegra.toString() === key ){
                if (formData[key] === etapaAtual.Resposta || formData[36] === etapaAtual.Resposta){
                    revisaoTecnica = formData[key]
                    revisaoComercial = formData['36'] // Definido no Código,achar solução melhor

                    proximaEtapa.categoria = etapaAtual.CategoriaIdDestino;
                    proximaEtapa.categoriaDescricao = etapaAtual.CategoriaDescricaoDestino;
                    proximaEtapa.etapa = etapaAtual.EtapaIdDestino;
                    proximaEtapa.etapaDescricao = etapaAtual.EtapaDescricaoDestino;
                }
            }
        });

        //Se na Etapa Seguinte, existir a "Duplicação do Card" é realizado o ajuste
        if (etapaSeguinte.TipoRegra === 1 && etapaSeguinte.Acao === 1 ){
            proximaEtapa.categoriaDuplica = etapaSeguinte.CategoriaIdDestino;
            proximaEtapa.categoriaDuplicaDescricao = etapaSeguinte.CategoriaDescricaoDestino;
            proximaEtapa.etapaDuplica = etapaSeguinte.EtapaIdDestino;
            proximaEtapa.etapaDuplicaDescricao = etapaSeguinte.EtapaDescricaoDestino;
        }
        
        //Se na Etapa Atual for definida a Regra de qual deve ser a proxima Etapa
        if (etapaAtual.TipoRegra === 2 && etapaAtual.Acao === 1 ){
            proximaEtapa.categoria = etapaAtual.CategoriaIdDestino;
            proximaEtapa.categoriaDescricao = etapaAtual.CategoriaDescricaoDestino;
            proximaEtapa.etapa = etapaAtual.EtapaIdDestino;
            proximaEtapa.etapaDescricao = etapaAtual.EtapaDescricaoDestino;
        }

        jsonSalvar.NumeroOrcamento = numeroOrcamento || null;
        jsonSalvar.Titulo = titulo || null;
        jsonSalvar.ResponsavelComercial = responsavelComercial || null;
        jsonSalvar.ResponsavelOrcamento = responsavelOrcamento || null;
        jsonSalvar.IsRevisaoTecnica = revisaoTecnica || 'NÃO';
        jsonSalvar.IsRevisaoComercial = revisaoComercial || 'NÃO';
        jsonSalvar.RevisaoTecnica = String( jsonSalvar.IsRevisaoTecnica == 'SIM' ? parseFloat(NumeroRevisaoTecnica) + 1: parseFloat(NumeroRevisaoTecnica) );
        jsonSalvar.RevisaoComercial = String( jsonSalvar.IsRevisaoComercial == 'SIM' ? parseFloat(NumeroRevisaoComercial) + 1 : parseFloat(NumeroRevisaoComercial) );
        jsonSalvar.Categoria = {CategoriaId: CategoriaId, CategoriaDescricao: etapaAtual.CategoriasDescricao, Sequencia: etapaAtual.SequenciaCat };
        jsonSalvar.Etapa = {EtapaId: EtapaId, EtapaDescricao: etapaAtual.EtapasDescricao };

        jsonSalvar.EtapaSeguinte = proximaEtapa;
        jsonSalvar.FinalCategoria = fimCategoria;
        jsonSalvar.Usuario = usuario.nome;
        
        if ((revisaoTecnica == 'SIM' || revisaoComercial == 'SIM' ) && revisaoAberto){
            ErroMsg('Já existe uma revisão em Aberto!')
            return false
        }
        
        try {
            setCarregar(true);
            const rota = 'processosCRM' + (isInclusao ? '/' : 
                                           ( ( jsonSalvar.IsRevisaoTecnica == 'SIM' || jsonSalvar.IsRevisaoComercial == 'SIM' )  ?  '/revisao/' : '/' ) + Id );
        
            const retConsumo = await (isInclusao
                ? ConsumoAPI_POST(rota, jsonSalvar)
                : ConsumoAPI_PUT(rota, jsonSalvar));
        
            SucessoMsg('Etapa Concluída com Sucesso!');
            navigateSubmit();
        } catch (error) {
            console.error('Error in handleSalvar:', error);
            // Handle the error, show an error message, or log it as needed.
            setCarregar(false);
        } finally {
            setCarregar(false);
        }
        // return false
    };
                        
    const navigateSubmit = () => {
        let caminho = '..'
            
        if (window.location.pathname.includes('Visualizar') ){
            caminho += '/..'
        }
        if (window.location.pathname.includes('Alterar') ){
            caminho += '/..'
        }
    
        navigate(caminho, { relative: "path" });
    }

    const renderField = (field) => {
        let obrigatorio = field.Obrigatorio === 'S'
        let desabilitado = !FormAtivo ? field.HabilitadoPreenchimento == "S" ? false : true : FormAtivo
        switch (field.TipoResposta) {
            case 'T':
                return (
                    <Form.Group key={field.IdPergunta}>
                        <Form.Label>{field.Descricao}:</Form.Label>
                        <Form.Control
                            type="text"
                            id={field.IdPergunta}
                            name={field.NameField.trim()}
                            onChange={handleChange}
                            onBlur={handleonBlur}
                            value={formData[field.IdPergunta] || ''}
                            required={obrigatorio}
                            disabled={desabilitado}
                        />
                    </Form.Group>
                );
            case 'P':
                return (
                    <Form.Group key={field.IdPergunta}>
                        <Form.Label>{field.Descricao}:</Form.Label>
                        <Form.Control
                            as="textArea"
                            id={field.IdPergunta}
                            name={field.NameField.trim()}
                            onChange={handleChange}
                            onBlur={handleonBlur}
                            value={formData[field.IdPergunta] || ''}
                            required={obrigatorio}
                            disabled={desabilitado}
                        />
                    </Form.Group>
                );
            case 'N':
                return (
                    <Form.Group key={field.IdPergunta}>
                        <Form.Label>{field.Descricao}:</Form.Label>
                        <Form.Control
                            type="number"
                            id={field.IdPergunta}
                            name={field.NameField.trim()}
                            onChange={handleChange}
                            onBlur={handleonBlur}
                            value={formData[field.IdPergunta] || ''}
                            required={obrigatorio}
                            disabled={desabilitado}
                        />
                    </Form.Group>
                );
            case 'M':
                return (
                    <Form.Group key={field.IdPergunta}>
                        <Form.Label>{field.Descricao}:</Form.Label>
                        {field.options.map(option => (
                            <Form.Check
                                key={option}
                                type="radio"
                                label={option}
                                id={field.IdPergunta}
                                name={field.NameField.trim()}
                                value={option}
                                onChange={handleChange}
                                onBlur={handleonBlur}
                                required={obrigatorio}
                                disabled={desabilitado}
                            />
                        ))}
                    </Form.Group>
                );
            case 'C':
                return (
                    <Form.Group key={field.IdPergunta}>
                        <Form.Label>{field.Descricao}:</Form.Label>
                        {field.options.map(option => (
                            <Form.Check
                                key={option}
                                type="checkbox"
                                label={option}
                                id={field.IdPergunta}
                                name={field.NameField.trim()}
                                value={option}
                                onChange={handleChange}
                                onBlur={handleonBlur}
                                disabled={desabilitado}
                            />
                        ))}
                    </Form.Group>
                );
            case 'L':
                let loptionDefault = true;
                let opcoesLista = [...field.options]
                
                if (opcoesLista.some(option => option.endsWith('.json'))){
                    loptionDefault = false;

                    opcoesLista = dataUsers;
                }
                return (
                    <Form.Group key={field.IdPergunta}>
                        <Form.Label>{field.Descricao}:</Form.Label>
                        <Form.Control
                            as="select"
                            id={field.IdPergunta}
                            name={field.NameField.trim()}
                            onChange={handleChange}
                            onBlur={handleonBlur}
                            value={formData[field.IdPergunta] || ''}
                            required={obrigatorio}
                            disabled={desabilitado}
                        >
                            <option value="">Select...</option>
                            { loptionDefault && field.options.map(option => (
                                <option key={option} value={option}>{option}</option>
                            ))}
                            
                            { !loptionDefault && opcoesLista.map(option => (
                                <option key={option.Id} value={option.Id}>{option.Descricao}</option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                );
            case 'A':
                return (
                    <Form.Group key={field.IdPergunta}>
                        <Form.Label>{field.Descricao}:</Form.Label>
                        <Form.Control
                            type="file"
                            id={field.IdPergunta}
                            name={field.NameField.trim()}
                            onChange={handleChange}
                            onBlur={handleonBlur}
                            value={formData[field.IdPergunta] || ''}
                            required={obrigatorio}
                            disabled={desabilitado}
                        />
                    </Form.Group>
                );
            case 'D':
                return (
                    <Form.Group key={field.IdPergunta}>
                        <Form.Label>{field.Descricao}:</Form.Label>
                        <Form.Control
                            type="date"
                            id={field.IdPergunta}
                            name={field.NameField.trim()}
                            onChange={handleChange}
                            onBlur={handleonBlur}
                            value={formData[field.IdPergunta] || ''}
                            required={obrigatorio}
                            disabled={desabilitado}
                        />
                    </Form.Group>
                );
            case 'H':
                return (
                    <Form.Group key={field.IdPergunta}>
                        <Form.Label>{field.Descricao}:</Form.Label>
                        <Form.Control
                            type="time"
                            id={field.IdPergunta}
                            name={field.NameField.trim()}
                            onChange={handleChange}
                            onBlur={handleonBlur}
                            value={formData[field.IdPergunta] || ''}
                            required={obrigatorio}
                            disabled={desabilitado}
                        />
                    </Form.Group>
                );
            case 'V':
                return (
                    <Form.Group key={field.IdPergunta}>
                        <Form.Label>{field.Descricao}:</Form.Label>
                        <Form.Control
                            type="number"
                            id={field.IdPergunta}
                            name={field.NameField.trim()}
                            step="0.01"
                            onChange={handleChange}
                            onBlur={handleonBlur}
                            value={formData[field.IdPergunta] || ''}
                            required={obrigatorio}
                            disabled={desabilitado}
                        />
                    </Form.Group>
                );
            case 'I':
                return (
                    <Form.Group key={field.IdPergunta}>
                        <Form.Label>{field.Descricao}:</Form.Label>
                        <Form.Control
                            type="number"
                            id={field.IdPergunta}
                            name={field.NameField.trim()}
                            onChange={handleChange}
                            onBlur={handleonBlur}
                            value={formData[field.IdPergunta] || ''}
                            required={obrigatorio}
                            disabled={true}
                        />
                    </Form.Group>
                );
            default:
                return null;
        }
    };

    const handleTabSelect = (index) => {
        setActiveTab(index);
    };

    const handleAddFiles = async(acceptedFiles, fileRejections, event) => {
        const allowedFileTypes = [
            'image/jpeg',
            'image/png',
            'application/pdf',
            'application/msword',
            'text/plain',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel', // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
            'text/csv' // .csv
        ];
        const isValidFileType = acceptedFiles.every(file => allowedFileTypes.includes(file.type));

        if (!isValidFileType) {
            toast.warning('Tipos de arquivo não permitidos. Faça o upload apenas de imagens (jpeg, png), PDF, DOC ou arquivos de texto.');
            return;
        }

        const retUpload = await ConsumoAPI_FileUpload(acceptedFiles);
        
        if (event){
            event.persist()
            event.preventDefault()
        }

        if (retUpload.error === "00") {
            const files = retUpload.data
            files.forEach( async(item) => {
                const fileJson = item ? JSON.stringify(item, null, 2) : "{}";;
            
                const jsonSalvar = { 
                    ProcessoCRMId: IdOrigem,
                    IdOrigem: Id,
                    Anexo: fileJson,
                    Usuario: usuario.nome
                };
    
                try {
                    const rota = 'processosCRM/anexos/';
                    const retConsumo = await ConsumoAPI_POST(rota, jsonSalvar);
                
                    if (retConsumo){
                        fetchAnexos()
                    }
                }catch(error){
                    console.error(error);
                }
            })
        }
    }

    // const handleDelFiles = (fileDelete) => {
    //     const updatedFiles = [...campoFile];
    //     updatedFiles.splice(fileDelete, 1);
        
    //     setCampoFile(updatedFiles)
    // }

    return (
        <>
            <LoadingSpinner isLoading={carregar}/>
            <Row>
                <Col md={2}>
                    <InputGeral
                        label="ID"
                        placeholder="Id"
                        tipo="numero"
                        value={IdOrigem}
                        step="0.01"
                        disabled={true}
                    />
                    {/* <Form.Group>
                        <Form.Label>Id</Form.Label>
                        <Form.Control
                            type="number"
                            step="0.01"
                            value={IdOrigem}
                            disabled={true}
                        />
                    </Form.Group> */}
                </Col>
                <Col md={10}>
                    <SelectDinamico
                        label="Clientes"
                        consulta={ConsultaCliente.consulta}
                        tabela={ConsultaCliente.tabelas}
                        cValue="Id"
                        cText="Nome + ' - ' + item.Nome_Unidade + '(' + item.CNPJ + ') - Contato: ' + item.Nome_Contato"
                        campoValue={campoCliente}
                        value={campoCliente}
                        disabled={campoCliente.value}
                        onchange={(e) => setCampoCliente(e)}
                    />
                </Col>
                {campoNumeroOrcamento && (
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>Numéro Orçamento</Form.Label>
                            <Form.Control
                                type="number"
                                step="0.01"
                                disabled={!isInclusao}
                                value={campoNumeroOrcamento}
                            />
                        </Form.Group>
                    </Col>
                )}
                {campoTitulo && (
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>Título</Form.Label>
                            <Form.Control
                                type="text"
                                value={campoTitulo}
                                disabled={true}
                            />
                        </Form.Group>
                    </Col>
                )}
                {/* <SDivDuplicar md={2}>
                { !!isInclusao && <Button variant="info" className="mt-3 w-100" onClick={handleDuplicate}>Duplicar Processo</Button> }
                </SDivDuplicar> */}
            </Row>
            <Col md={12}>
                <Tabs activeKey={activeTab} onSelect={handleTabSelect} id="tab-panel" >
                    <Tab key={"Principal"} eventKey={"Principal"} title={"Etapa Atual"}>
                        <Container className="mt-5">
                            <Row>
                                <Col md={6}>
                                    <h4>{titleForm}</h4>
                                    <br/>
                                    <Form onSubmit={handleSubmit}>
                                        {fields.map(field => renderField(field))}
                                        { !FormAtivo && <Button type="submit" className="mt-3 w-100">Avançar para a proxima Etapa</Button> }
                                    </Form>
                                </Col>
                                <Col md={6}>
                                    <h4>Histórico de Alterações</h4>
                                    <br/>
                                    {history.map((item, index) => {
                                        return (<Card key={index} className="mb-3">
                                            <Card.Body>
                                                <Card.Text><strong>Data:</strong> {item.DataFormatada} - <strong>Hora:</strong> {item.HoraFormatada}</Card.Text>
                                                <Card.Text><strong>Usuário:</strong> {item.Usuario}</Card.Text>
                                                <Card.Text><strong>Alteração:</strong> {item.Acao}</Card.Text>
                                            </Card.Body>
                                        </Card>
                                    )})}
                                </Col>
                            </Row>
                        </Container>
                    </Tab>
                    <Tab key={"Negocios"} eventKey={"Negocios"} title={"Negócios Derivados"}>
                        <br/>
                        <h4>Negócios Derivados</h4>
                        <br/>
                        {  dataNegocios && dataNegocios.length > 0 && (
                            <ResponsiveDataTable
                                columns={[
                                    {
                                        Header: 'Revisão Comercial',
                                        accessor: 'RevisaoComercial'
                                    },
                                    {
                                        Header: 'Revisão Técnica',
                                        accessor: 'RevisaoTecnica'
                                    },
                                    {
                                        Header: 'Data Proposta Comercial',
                                        accessor: 'DataPropostaComercial',
                                        Cell: handleData
                                    },
                                    {
                                        Header: 'Data Proposta Técnica',
                                        accessor: 'DataPropostaTecnica',
                                        Cell: handleData
                                    },
                                    {
                                        Header: 'Valor Fechamento',
                                        accessor: 'ValorFechamento',
                                        Cell: handleValorMonetario
                                    },
                                    {
                                        Header: 'Valor Custo',
                                        accessor: 'ValorCusto',
                                        Cell: handleValorMonetario
                                    },
                                    {
                                        Header: 'Valor Aprovação Custo',
                                        accessor: 'ValorAprovacaoCusto',
                                        Cell: handleValorMonetario
                                    },
                                    {
                                        Header: 'Valor Proposta Comercial',
                                        accessor: 'ValorPropostaComercial',
                                        Cell: handleValorMonetario
                                    },
                                    {
                                        Header: 'Responsável Orçamento',
                                        accessor: 'ResponsavelpeloOrcamento'
                                    },
                                    {
                                        Header: 'Classificacao',
                                        accessor: 'Classificacao'
                                    }
                                ]}
                                data={dataNegocios}
                                isIgnorar={true}
                                habilitaBuscar={false}
                                buttons={[]}
                                habilitaCheckBox={false}
                            />
                        )}
                    </Tab>
                    <Tab key={"Documentos"} eventKey={"Documentos"} title={"Documentos Anexados"}>
                        <br/>
                        <h4>Documentos Anexados</h4>
                        <br/>
                        <UploadFiles 
                            onDropEvent={handleAddFiles}
                            value={campoFile}
                        />

                        <br/>
                        {  dataAnexos && dataAnexos.length > 0 && (
                            <ResponsiveDataTable
                                columns={[
                                    {
                                        Header: 'Anexo',
                                        accessor: 'Anexo',
                                        Cell: handleAnexosCRM
                                    }
                                ]}
                                data={dataAnexos}
                                isIgnorar={true}
                                habilitaBuscar={false}
                            />
                        )}
                    </Tab>
                </Tabs>
            </Col>
        </>
    );
};

export default FormularioCRM;
